module.exports = __webpack_public_path__ + "img/particle_motion_00076.01d53866.png";